import createVueComponent from '../createVueComponent';

const Undo = createVueComponent('UndoIcon', [
  ['path', { d: 'M3 7v6h6' }],
  ['path', { d: 'M21 17a9 9 0 00-9-9 9 9 0 00-6 2.3L3 13' }],
]);

export default Undo;
